import React from "react";
import ProductBasicInformation from "./ProductBasicInformation";
import ProductCategoryInformation from "./ProductCategoryInformation";
import ProductPricingInformation from "./ProductPricingInformation";
import ProductInventoryInformation from "./ProductInventoryInformation";
import ProductTaxInformation from "./ProductTaxInformation";
import ProductVariantInformation from "./ProductVariantInformation";
import ProductMedicineInformation from "./ProductMedicineInformation";
import ProductServiceInformation from "./ProductServiceInformation";
import ProductImageUploader from "./ProductImageUploader";
import ProductDescription from "./ProductDescription";
import ProductItemGrid from "./ProductItemGrid";
import ProductStatus from "./ProductStatus";
import ProductSpecifications from "./ProductSpecifications";
// import "../../../../assets/css/addProduct.scss"
function ProductFormRenderer({ form, dropdown, config, users, mode = "create" }) {
    const component = config?.components || {};
    const isView = mode === "view";
    const isEdit = mode === "edit";
    const isCreate = mode === "create";
    return (
        <>
        
            {component.basic && (
                <div className="mb-3">
                    <ProductBasicInformation
                        formData={form.formData}
                        errors={form.errors}
                        users={dropdown.users}
                        brands={dropdown.brands}
                        handleChange={form.handleChange}
                        config={config}
                        mode={mode}
                        handleUserChange={(e) => {
                            form.handleUserChange(
                                e,
                                users,
                                dropdown.loadSubCategory,
                                dropdown.loadDynamicDropdowns,
                                // config={config}
                            )
                        }}
                    />
                </div>
            )}

            {component.category && (
                <div className="mb-3">
                    <ProductCategoryInformation
                        formData={form.formData}
                        errors={form.errors}
                        categories={dropdown.categories}
                        config={config}
                        subCategories={dropdown.subCategories}
                        // setSelectedSubCategorySlug={form.setSelectedSubCategorySlug}
                        setSelectedSubCategory={form.setSelectedSubCategory}
                        mode={mode}
                        brands={dropdown.brands}
                        units={dropdown.units}
                        handleChange={form.handleChange}
                        handleCategoryChange={(e) => {
                            form.handleCategoryChange(e,
                                dropdown.loadSubCategory
                            );
                        }}
                        setSubCategorySlug={(slug) => {
                            // ✅ SLUG SET KARO
                            form.setSelectedSubCategorySlug(slug);
                            // ✅ FORMDATA MEIN BHI SET KARO
                            form.handleChange({
                                target: {
                                    name: 'subcategory_slug',
                                    value: slug
                                }
                            });
                        }}

                    />
                </div>
            )}

            {component.pricing && (
                <div className="mb-3">
                    <ProductPricingInformation
                        formData={form.formData}
                        errors={form.errors}
                        mode={mode}
                        handleChange={form.handleChange}
                        handleNumberInput={form.handleNumberInput}
                        config={config}
                    />
                </div>
            )}


            {component.inventory && (
                <div className="mb-3">
                    <ProductInventoryInformation
                        formData={form.formData}
                        // onChange={form.handleChange}
                        mode={mode}
                        handleChange={form.handleChange}
                        errors={form.errors}
                        units={dropdown.units}
                        handleNumberInput={form.handleNumberInput}
                        config={config}
                    />
                </div>
            )}

            {component.tax && (
                <div className="mb-3">
                    <ProductTaxInformation
                        formData={form.formData}
                        errors={form.errors}
                        handleChange={form.handleChange}
                        mode={mode}
                        handleNumberInput={form.handleNumberInput}
                        config={config}
                    />
                </div>
            )}

            {component.variants && (
                <div className="mb-3">
                    <ProductVariantInformation
                        formData={form.formData}
                        colors={dropdown.colors}
                        sizes={dropdown.sizes}
                        variantForm={form.variantForm}
                        mode={mode}
                        handleVariantChange={form.handleVariantChange}
                        handleVariantSelect={form.handleVariantSelect}
                        editVariantIndex={form.editVariantIndex}
                        handleChange={form.handleChange}
                        addVariant={form.addVariant}
                        deleteVariant={form.deleteVariant}
                        errors={form.errors}
                        handleSelectChange={form.handleSelectChange}
                        config={config}
                    />
                </div>
            )}

            {component.specifications && (
                <div className="mb-3">
                    <ProductSpecifications
                        formData={form.formData}
                        errors={form.errors}
                        colors={dropdown.colors}
                        mode={mode}
                        sizes={dropdown.sizes}
                        handleChange={form.handleChange}
                        handleSpecificationSelect={form.handleSpecificationSelect}
                        config={config}
                    />
                </div>
            )}

            {
                component.medicine && (
                    <div className="mb-3">
                        <ProductMedicineInformation
                            formData={form.formData}
                            handleChange={form.handleChange}
                            config={config}
                            mode={mode}
                        />
                    </div>
                )}

            {component.service && (
                <div className="mb-3">
                    <ProductServiceInformation
                        formData={form.formData}
                        errors={form.errors}
                        mode={mode}
                        handleChange={form.handleChange}
                        config={config}
                    />
                </div>
            )}
            {component.image && (
                <div className="mb-3">
                    <ProductImageUploader
                        formData={form.formData}
                        imagePreview={form.imagePreview}
                        errors={form.errors}
                        mode={mode}
                        handleChange={form.handleChange}
                    />
                </div>
            )}
            {
                component.description && (
                    <div className="mb-3">
                        <ProductDescription
                            formData={form.formData}
                            handleChange={form.handleChange}
                            mode={mode}
                            config={config}
                        />
                    </div>
                )}
            {
                component.status && (
                    <div className="mb-3">
                        <ProductStatus
                            formData={form.formData}
                            handleChange={form.handleChange}
                            mode={mode}
                            config={config}
                        />
                    </div>
                )}
            {
                form.formData?.variants?.length > 0 && (
                    <div className="mb-3">
                        <ProductItemGrid
                            variants={form.formData.variants}
                            config={config}
                            onEdit={isView ? null : form.editVariant}
                            onDelete={isView ? null : form.deleteVariant}
                            mode={mode}
                            // onDelete={form.deleteVariant}
                        />
                    </div>
                )
            }



        </>
    );

}

export default ProductFormRenderer;
